/////////////////////////////////
//MAP rendering in location page
/////////////////////////////////
// Initialize and add the map
// This example requires the Places library. Include the libraries=places
// parameter when you first load the API. For example:
// <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
// Places API Key: AIzaSyAI_0F2fAJi0qLpdEtwvwXJTGm1YPRAKdU
// let location_map = document.querySelector("#location_map");
// if(location_map) {
//   let place_id = location_map.dataset.placeid;
//   if(place_id != '' && place_id != null) {
//     //load the map
//     function initMap() {
//       const map = new google.maps.Map(document.getElementById("location_map"), {
//         zoom: 12,
//         mapId: "7b740c6fdd51f4dc",
//       });
//       const request = {
//         placeId: place_id,
//         fields: ["name", "formatted_address", "rating", "geometry", "url"],
//       };
//       const infowindow = new google.maps.InfoWindow();
//       const service = new google.maps.places.PlacesService(map);

// const { init } = require("browser-sync");

    
//       service.getDetails(request, (place, status) => {
//         if (
//           status === google.maps.places.PlacesServiceStatus.OK &&
//           place &&
//           place.geometry &&
//           place.geometry.location) {
//           // The advanced marker, positioned at Uluru
//           const marker = new google.maps.marker.AdvancedMarkerElement({
//             map,
//             position: place.geometry.location,
//             title: "View location information",
//           });
//           map.setCenter(place.geometry.location);
    
//           function getInfoWindow() {
//             const content = document.createElement("div");
//             content.setAttribute('class', 'info');
//             // content.innerHTML +='<div class="acw-logo"><img src="https://www.airculinaireworldwide.com/wp-content/uploads/2020/04/Air-Culinaire-Worldwide_Pref-A_Horizontal-Logo-300x100.png" alt="ACW Logo"></div>';
//             //name
//             const nameElement = document.createElement("p");
//             nameElement.setAttribute('class', 'info__title');
//             nameElement.textContent = place.name;
//             content.appendChild(nameElement);
    
//             //address
//             const placeAddressElement = document.createElement("div");          
//             placeAddressElement.setAttribute('class', 'info__address');
//             placeAddressElement.textContent = place.formatted_address;
//             content.appendChild(placeAddressElement);

//             //rating
//             const placeRatingElement = document.createElement("div");
//             const starRating = document.createElement("div");
//             placeRatingElement.setAttribute('class', 'info__rating fw-bold font-montserrat');
//             placeRatingElement.textContent = place.rating;
//             // content.appendChild(placeRatingElement);
    
//             //link
//             const buttonElement = document.createElement("a");
//             buttonElement.setAttribute('class', 'info__button external-link');
//             buttonElement.setAttribute('href', place.url);
//             buttonElement.setAttribute('target', '_blank');
//             // buttonElement.textContent = 'View location';
//             buttonElement.innerHTML += '<span>View location</span> <i class="fa-sharp fa-regular fa-arrow-up-right-from-square"></i>';
//             content.appendChild(buttonElement);
    
//             //set and display
//             infowindow.setContent(content);
//             infowindow.open(map, marker);
//           }          
    
//           google.maps.event.addListener(marker, "click", () => {
//             getInfoWindow();
//           });
          
//           google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
//             getInfoWindow();
//             // map.panBy(0, -100);
//           });
    
//         }
//       });
//     }
//     setTimeout(()=>{
//       window.initMap = initMap;
//     }, 500)
//     if(location_map.classList.contains('loading')) location_map.classList.remove('loading');
//   } else {
//     let map_wrapper = document.querySelector('.map-wrapper');
//     map_wrapper.textContent = "Map data is not available.";
//     if(location_map.classList.contains('loading')) location_map.classList.remove('loading');
//   }
// }